import { render } from "./stacked.vue?vue&type=template&id=bb6210d2"
import script from "./stacked.vue?vue&type=script&lang=js"
export * from "./stacked.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__